<!-- クーポンコード認証失敗 使用済み -->
<template>
  <ItemDialog ref="expiredCouponCode" image-type="alert">
    <template #content-area>
      <h2>
        {{ $t("MyTicketTicketing.couponCodeFailed.title") }}
      </h2>
      <p class="text-center">引き換え可能期間外です</p>
    </template>
    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>
s
<script>
export default {
  name: "DialogExpiredCouponCode",
  methods: {
    async openDialog() {
      this.$refs.expiredCouponCode.open();
    },
    async closeDialog() {
      this.$refs.expiredCouponCode.close();
    },
  },
};
</script>
